import { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setMotorBikesData } from '../../redux/divisionMotorBikesReducer'
import { errorMessage, openMessage, successfullyMessage } from '../Messages'
import { getMotorBikesData } from '../divisionMotorBikes/services/getMotorBikesData'

export function useInitMotorBikesData({ data, fDate, eDate, division, date = undefined }) {

    const dispatch = useDispatch()
    const [lastFilterDates, setLastFilterDates] = useState({})

    const initMotorBikeData = useCallback(async () => {
        openMessage({ message: "Cargando..." })
        const { result, message, error_msg } = await getMotorBikesData({ fDate, eDate, division, date })
        if (message.includes('Successfully')) {
            successfullyMessage({ message: "Datos Cargados" })
            dispatch(setMotorBikesData(result))
        } else if (!!error_msg) {
            errorMessage({ message: "Ocurrió un error" })
        }
    }, [dispatch, fDate, eDate, division, date])

    useEffect(() => {
        (async () => {
            if (data?.length > 0 && !!fDate && !!eDate) {
                if (fDate !== lastFilterDates?.fDate || eDate !== lastFilterDates?.eDate) {
                    initMotorBikeData()
                    setLastFilterDates({ ...lastFilterDates, fDate: fDate, eDate: eDate })
                }
            } else if (data?.length === 0 && !!fDate && !!eDate) {
                initMotorBikeData()
                setLastFilterDates({ ...lastFilterDates, fDate: fDate, eDate: eDate })
            }
        })()
    }, [data, fDate, eDate, division, date])

}